import { DateTime } from 'luxon';

export interface ISpeculationRule {
  enabled: boolean;
  page_url_regexp: string;
  whitelist_path_patterns: string[];
  blacklist_path_patterns: string[];
  dp_state: string;
  dp_activated_at: string | null;
}

class SpeculationRule {
  public readonly enabled: boolean;
  public readonly pageUrlRegexp: string;
  public readonly whitelistPathPatterns: string[];
  public readonly blacklistPathPatterns: string[];
  public readonly dpState: string;
  public readonly dpActivatedAt: DateTime | null;

  constructor({
    enabled,
    pageUrlRegexp,
    whitelistPathPatterns,
    blacklistPathPatterns,
    dpState,
    dpActivatedAt,
  }: {
    enabled: boolean;
    pageUrlRegexp: string;
    whitelistPathPatterns: string[];
    blacklistPathPatterns: string[];
    dpState: string;
    dpActivatedAt: DateTime | null;
  }) {
    this.enabled = enabled;
    this.pageUrlRegexp = pageUrlRegexp;
    this.whitelistPathPatterns = whitelistPathPatterns;
    this.blacklistPathPatterns = blacklistPathPatterns;
    this.dpState = dpState;
    this.dpActivatedAt = dpActivatedAt;
  }

  public static fromAPI = (data: ISpeculationRule): SpeculationRule => {
    return new SpeculationRule({
      enabled: data.enabled,
      pageUrlRegexp: data.page_url_regexp,
      whitelistPathPatterns: data.whitelist_path_patterns,
      blacklistPathPatterns: data.blacklist_path_patterns,
      dpState: data.dp_state,
      dpActivatedAt: data.dp_activated_at ? DateTime.fromISO(data.dp_activated_at) : null,
    });
  };

  public toAPI = () => ({
    enabled: this.enabled,
    page_url_regexp: this.pageUrlRegexp,
    whitelist_path_patterns: this.whitelistPathPatterns,
    blacklist_path_patterns: this.blacklistPathPatterns,
  });
}

export default SpeculationRule;
